import React from 'react'
import { SxProps, styled } from '@mui/material/styles'
import { primary, error, leastText } from '@/constant'
import ClearIcon from '@mui/icons-material/Clear'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh'

export const InputArea = styled('div', {
  shouldForwardProp: (prop) => prop !== 'focused' && prop !== 'placeholder',
})<{ focused?: 'true' | 'false'; placeholder?: string }>(
  ({ focused = 'false', placeholder = '' }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    gap: '4px',
    borderBottom: '1px #DADCE0 solid',
    outline: 'none',
    padding: '4px 0',
    ...(focused === 'false' && {
      '&:hover': {
        borderBottom: '2px #DADCE0 solid',
      },
    }),
    ...(focused === 'true' && {
      transition: 'all 0.2s ease-in-out',
      borderBottom: `2px ${primary} solid`,
      '&:before': {
        content: `'${placeholder}'`,
        color: leastText,
        position: 'absolute',
      },
    }),
  })
)

export const InputBox = styled('input')(() => ({
  outline: 'none',
  border: 'none',
  background: 'transparent',
  paddingBottom: '4px',
}))

export const TagComponent = styled('span')(() => ({
  display: 'inline-block',
  padding: '0px 4px',
  backgroundColor: '#F7F7F7',
  border: '1px solid #D9D9D9',
  fontSize: '14px',
  lineHeight: '22px',
  color: '#041B0F',
  borderRadius: '4px',
  cursor: 'default',
}))

export type TagVariant = 'text' | 'email' | 'syslog';

   // @ts-ignore
function isValidIPAddressWithPort(ipWithPort) {
  // 定义正则表达式，用于匹配IP地址和端口号
  const pattern =
    /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(:([0-9]{1,5}))?$/
  const match = ipWithPort.match(pattern)
  if (!match) {
    return false
  }

  // 提取IP地址部分
  const ip = `${match[1]  }.${  match[2]  }.${  match[3]  }.${  match[4]}`

  // 检查端口号是否在有效范围内
  const port = match[6]
  if (port && (port < 1 || port > 65535)) {
    return false
  }

  // 检查是否为保留IP地址
  const parts = ip.split('.').map(Number)
  if (
    parts[0] === 10 || // 10.0.0.0 - 10.255.255.255 (A类内网)
    (parts[0] === 172 && parts[1] >= 16 && parts[1] <= 31) || // 172.16.0.0 - 172.31.255.255 (B类内网)
    (parts[0] === 192 && parts[1] === 168) || // 192.168.0.0 - 192.168.255.255 (C类内网)
    parts[0] === 127 || // 127.0.0.0 - 127.255.255.255 (环回地址)
    (parts[0] === 169 && parts[1] === 254)
  ) {
    // 169.254.0.0 - 169.254.255.255 (链接本地地址)
    return false
  }

  return true
}

const validateTagContent = (type: TagVariant, value: string) => {
  switch (type) {
    case 'text': {
      return true
    }
    case 'email': {
      const emailTest = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
      return emailTest.test(value)
    }
    case 'syslog': {
      return isValidIPAddressWithPort(value)
    }
  }
}

export const Tag = ({
  text,
  onDelete,
  variant,
  noDelete,
  sx,
}: {
  text: string;
  onDelete: () => void;
  variant?: TagVariant;
  noDelete?: boolean;
  sx?: SxProps;
}) => {
  return (
    <TagComponent sx={sx}>
      {/*  @ts-ignore */}
      {!validateTagContent(variant, text) && (
        <PriorityHighIcon sx={{ color: error, fontSize: '14px' }} />
      )}
      {text}
      {!noDelete && (
        <ClearIcon
          onClick={onDelete}
          sx={{
            fontSize: '65%',
            marginLeft: '8px',
            cursor: 'pointer',
            color: '#999999',
          }}
        />
      )}
    </TagComponent>
  )
}
